<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
          Click Me
        </v-btn>
      </template> -->

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Agregar dias de retraso
        </v-card-title>

        <v-card-text>
          <v-row class="mt-6" no-gutters>
            <v-col>
              <p class="mb-0"><b>Inscripcion ID:</b> {{ xdatos.inscripcion_id }}</p>
              <p class="mb-4"><b>Cuota ID:</b> {{ xdatos.cuota_id }}</p>
            </v-col>
            <v-col>
              <v-text-field
                v-model.number="xdatos.dias_retraso"
                type="number"
                dense
                outlined
                label="Dias de retraso:"
                hide-details
              />
            </v-col>
          </v-row>
          <p class="my-0 text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" :disabled="loading" outlined @click="dialog = false">
            <v-icon small left> mdi-close </v-icon>
            Cerrar
          </v-btn>
          <v-btn color="success" :disabled="loading" outlined @click="guardarDiasRetraso()">
            <v-icon small left> mdi-check </v-icon>
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        xdatos: {
          inscripcion_id: null,
          dias_retraso: null,
          cuota_id: null,
        },
      };
    },
    methods: {
      openmodal(datos) {
        this.xdatos.inscripcion_id = datos.inscripcion_id;
        this.xdatos.dias_retraso = datos.dias_retraso;
        this.xdatos.cuota_id = datos.cuota_id;
        this.dialog = true;
        this.loading = false;
        this.msg = '';
      },
      guardarDiasRetraso() {
        this.msg = '';
        if (!this.xdatos.inscripcion_id) this.msg = 'Falta el id de la inscripcion.';
        if (!this.xdatos.cuota_id) this.msg = 'Falta el id de la cuota.';
        if (!this.xdatos.dias_retraso) this.msg = 'Ingrese una cantidad de dias validos.';
        if (this.msg) return;
        let vue = this;
        this.loading = true;

        let url = `${process.env.VUE_APP_API_REST}/api/esam/inscripcion/change/plan/dates/cascade`;
        xaxios
          .put(url, this.xdatos)
          .then((res) => {
            vue.loading = false;
            window.console.log(res.data);
            vue.msg = res.data.result;
            if (vue.msg == 'success') {
              vue.$emit('successdias');
              setTimeout(() => {
                vue.dialog = false;
              }, 1000);
            }
          })
          .catch((error) => {
            vue.loading = false;
            window.console.error(error);
          });
      },
    },
  };
</script>
